import Vue from 'vue'
import Router from 'vue-router'
import api from '@/api'
import Home from '@/components/Home'
import Login from '@/components/auth/Login'
import Register from '@/components/auth/Register'
import Athlete from '@/components/Athlete'
import BodyLog from '@/components/athlete/BodyLog'
import Sessions from '@/components/Sessions'
import Session from '@/components/sessions/Session'
import Records from '@/components/Records'
import RecordLog from '@/components/records/RecordLog'
import InitRecords from '@/components/records/InitRecords'
import Coach from '@/components/Coach'
import ProgramEdit from '@/components/coach/ProgramEdit'
import Credits from '@/components/Credits'
import Device from '@/components/Device'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        public: true
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        public: true
      }
    },
    {
      path: '/athlete',
      name: 'Athlete',
      component: Athlete,
      props: true
    },
    {
      path: '/sessions',
      name: 'Sessions',
      component: Sessions,
      props: true
    },
    {
      path: '/session/:session',
      name: 'Session',
      component: Session,
      props: true
    },
    {
      path: '/records',
      name: 'Records',
      component: Records,
      props: true
    },
    {
      path: '/records-init',
      name: 'InitRecords',
      component: InitRecords,
      props: true
    },
    {
      path: '/record-log/:skill',
      name: 'RecordLog',
      component: RecordLog,
      props: true
    },
    {
      path: '/body-log',
      name: 'BodyLog',
      component: BodyLog,
      props: true
    },
    {
      path: '/coach',
      name: 'Coach',
      component: Coach,
      props: true
    },
    {
      path: '/coach/program-edit',
      name: 'ProgramEdit',
      component: ProgramEdit,
      props: true
    },
    {
      path: '/credits',
      name: 'Credits',
      component: Credits,
      props: true
    },
    {
      path: '/device',
      name: 'Device',
      component: Device,
      props: true
    }
  ]
})

// intercept routing for auth
router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!api.hasCurrentUser()

  if (!isPublic && !loggedIn) {
    return next({
      name: 'Login',
      query: {redirect: to.fullPath} // Store the full path to redirect the user to after login
    })
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next({name: 'Home'})
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js